<template>
  <div class="text-center">
    <v-dialog
      v-model="localDialog"
      persistent
      width="500"
      content-class="calculadora-dialog"
    >
      <template #activator="{ on, attrs }">
        <v-btn
          v-if="false"
          color="red lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
        ></v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2 text-break">
          {{
            !titulo
              ? typeError.code == "errorResponseEmpty"
                ? $t("errores.alert.errorNoResultHead")
                : $t("errores.alert.genericTitleError")
              : titulo
          }}
        </v-card-title>

        <v-card-text v-if="typeError">
          <template v-if="typeError.code == 'errorTamEstampacion'">
            <h4>
              {{
                $t("errores.alert.errorTamEstampacionHead", {
                  size: $t("zonas." + formatZona(typeError.zone.Zona))
                })
              }}
            </h4>
            {{
              $t("errores.alert.errorTamEstampacionBody", {
                talla:
                  typeError.tamEstampacion +
                  (typeError.tamEstX && typeError.tamEstY
                    ? " (" + typeError.tamEstX + "x" + typeError.tamEstY + "mm)"
                    : "cm2")
              })
            }}
            <br />
            <template v-if="typeError.listProduct?.length">
              <h4 class="mt-4">
              <u>{{ $t("errores.alert.errorTamEstampacionListHead") }}</u>
            </h4>
            <ul>
              <li
                v-for="talla in typeError.listProduct"
                :key="talla.Descripcion"
              >
                {{ talla.Descripcion }} ({{ talla.Ancho }}x{{ talla.Alto }}mm)
              </li>
            </ul>
            </template>
          </template>
          <template v-if="typeError.code == 'errorMinUnit'">
            <h4>
              {{
                $t("errores.alert.errorMinUnitTitleHead", {
                  minUnit: typeError.minUnit
                }) +
                (typeError.productCode ? ` (${typeError.productCode})` : "")
              }}
            </h4>
          </template>
          <template v-if="typeError.code == 'errorModelNotFound'">
            <h4>{{ $t("errores.alert.errorModelNotFound") }}</h4>
          </template>
          <template v-if="typeError.code == 'errorNoMoq'">
            <h4>
              {{
                $t("errores.alert.errorMoq", {
                  moq: typeError.minUnit,
                  productCode: typeError.productCode
                    ? ` (${typeError.productCode})`
                    : ""
                })
              }}
            </h4>
          </template>
          <template v-if="typeError.code == 'maxPrice'">
            <h4 class="mt-4">{{ $t("errores.alert.alertMaxPrice") }}</h4>
          </template>
          <template v-if="typeError.code == 'errorResponseEmpty'">
            <h4 class="mt-4">{{ $t("errores.alert.errorNoResultBody") }}</h4>
          </template>
          <template v-if="typeError.code == 'errorMin'">
            <h4 class="mt-4">
              {{ $t("errores.alert.errorMinTecnica", { minUnit: typeError.minUnit }) }}
            </h4>
          </template>
          <template v-if="typeError.code == 'errorColorBanned'">
            <h4 class="mt-4">
              {{ $t("errores.alert.errorColorBanned", { color: typeError.product }) }}
            </h4>
          </template>
          <template v-if="typeError.code == 'alertInvalidFileTypeReprocesos'">
            <h4 class="mt-4">
              {{ $t("errores.alert.alertInvalidFileTypeReprocesos") }}
            </h4>
          </template>
          <template v-if="typeError.code == 'WarningProductNoStock'">
            <div class="text-left pt-2">
              <div class="d-flex align-center mb-3">
                <v-icon color="error" class="mr-2">mdi-package-variant-remove</v-icon>
                <span class="font-weight-bold text-subtitle-1">{{
                  $t("errores.alert.warningProductNoStock")
                }}</span>
              </div>

              <div class="stock-errors-scroll">
                <div
                  v-for="item in typeError.listProducts"
                  :key="item.productCode"
                  class="stock-error-row px-2 py-3"
                >
                  <div class="d-flex align-center w-100">
                    <!-- Producto y reprocesos -->
                    <div class="flex-grow-1 pr-3">
                      <div class="d-flex align-center mb-1 flex-wrap">
                        <span class="product-code-header mr-2">{{ item.productCode }}</span>
                        <div class="repro-ids-group d-flex flex-wrap">
                          <span v-for="id in item.reprocesosIds" :key="id" class="text-caption grey--text mr-1">#{{ id }}</span>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Cantidad (columna fija) -->
                    <div class="quantity-column mr-4">
                      <div class="text-caption grey--text mb-n1 text-center">{{ $t("general.Cantidad") }}</div>
                      <div class="text-subtitle-2 font-weight-medium text-center">
                        {{ item.quantity }} <span class="success--text font-weight-bold">/ {{ item.stockLimit }}</span>
                      </div>
                    </div>

                    <!-- Déficit (alineado a la derecha con ancho fijo) -->
                    <div class="deficit-column">
                      <div class="deficit-text error--text font-weight-bold">
                        -{{ item.quantity - item.stockLimit }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="cerrar">
            {{ botonCerrar }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
      cargando: false
    },
    titulo: {
      type: String,
      default: ""
    },
    cuerpo: {
      type: String,
      default: ""
    },
    botonCerrar: {
      type: String,
      default: ""
    },
    typeError: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      localDialog: this.dialog
    };
  },
  methods: {
    ...mapActions("modelo", ["clearAlert"]),
    cerrar: function () {
      this.localDialog = false;
      this.$emit("cerrar");
    },
    formatZona(value) {
      return value.toUpperCase().replace(/_/g, " ");
    }
  },
  watch: {
    dialog(newVal) {
      if (newVal != this.localDialog) this.localDialog = newVal;
    },
    localDialog(newVal) {
      if (newVal != this.dialog) {
        this.clearAlert();
        this.$emit("cerrar");
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/static/scss/_variables.scss";

.stock-errors-scroll {
  max-height: 380px;
  overflow-y: auto;
  border: 1px solid #f2f2f2;
  border-radius: 8px;
  background: #fafafa;
  margin-top: 8px;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #e0e0e0;
    border-radius: 10px;
  }
}

.stock-error-row {
  background: white;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s;
  
  &:hover {
    background: #fdfdfd;
  }
  
  &:last-child {
    border-bottom: none;
  }
}

.product-code-header {
  font-family: $heading-font-family;
  font-weight: 800;
  font-size: 1rem;
  letter-spacing: -0.2px;
}

.quantity-column {
  min-width: 90px;
  flex-shrink: 0;
}

.deficit-column {
  min-width: 70px;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-left: 8px;
}

.deficit-text {
  font-size: 1.25rem;
  line-height: 1.2;
}

.calculadora-dialog {
  .v-card__text {
    padding-bottom: 24px;
    padding-top: 20px !important;
  }
}
</style>
